<template>
	<div>
		<!-- <label class="col-form-label col-md-12 formRequired"> <span>ИНН</span> </label> -->
		<base-input
			v-model="bufferValue"
			type="text"
			:name="errorLabel"
			:error="getError(errorLabel)"
			:placeholder="placeholder"
			v-validate="{inn:true}"
		></base-input>
	</div>
</template>

<script>
	export default {
		name: 'ReInputINN',
		components: {

		},
		props: {
			value: String,
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			errorLabel: {
                String,
                default:'ИНН',
            },
			placeholder: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				bufferValue:'',
			}
		},
		watch:{
			value(val){
				this.bufferValue = this.$GVO.unlinkObject(val);
			},
			bufferValue(val){
				/*
				val = this.$GVO.str_replace(' ','',val);
				let number1 = this.$GVO.number_format(val,0,'.',' ');
				if(number1 == 0 ){ number1= ''; }
                */
				this.bufferValue = val;
				this.$emit("input", this.bufferValue);
			},
		},
		computed: {

		},
		methods: {
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
		},
		mounted() {
			this.bufferValue = this.value;
		}
	}
</script>
<style scoped>

</style>
